import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=64b2c6ae"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=64b2c6ae&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b2c6ae')) {
      api.createRecord('64b2c6ae', component.options)
    } else {
      api.reload('64b2c6ae', component.options)
    }
    module.hot.accept("./AppBar.vue?vue&type=template&id=64b2c6ae", function () {
      api.rerender('64b2c6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/guest/AppBar.vue"
export default component.exports